import React from 'react';
import './Skeleton.css';

export function SkeletonEntryCard() {
  return (
    <div className="skeleton-card">
      <div className="skeleton-header">
        <div className="skeleton-circle" />
        <div className="skeleton-lines">
          <div className="skeleton-line skeleton-line--md" />
          <div className="skeleton-line skeleton-line--sm" />
        </div>
      </div>
      <div className="skeleton-body">
        <div className="skeleton-badge" />
        <div className="skeleton-rating" />
        <div className="skeleton-line skeleton-line--full" />
        <div className="skeleton-line skeleton-line--full" />
        <div className="skeleton-line skeleton-line--lg" />
      </div>
      <div className="skeleton-footer">
        <div className="skeleton-btn" />
        <div className="skeleton-btn" />
      </div>
    </div>
  );
}

export function SkeletonProfileCard() {
  return (
    <div className="skeleton-card skeleton-card--profile">
      <div className="skeleton-avatar" />
      <div className="skeleton-line skeleton-line--md" style={{ margin: '1rem auto 0.5rem' }} />
      <div className="skeleton-line skeleton-line--sm" style={{ margin: '0 auto' }} />
    </div>
  );
}

export function SkeletonNavCard() {
  return (
    <div className="skeleton-card skeleton-card--nav">
      <div className="skeleton-icon-placeholder" />
      <div className="skeleton-line skeleton-line--md" style={{ margin: '0 auto 0.5rem' }} />
      <div className="skeleton-line skeleton-line--full" />
      <div className="skeleton-line skeleton-line--lg" />
      <div className="skeleton-btn skeleton-btn--full" />
    </div>
  );
}

export function SkeletonFormCard() {
  return (
    <div className="skeleton-card skeleton-card--form">
      {[1, 2, 3].map(i => (
        <div key={i} className="skeleton-form-group">
          <div className="skeleton-line skeleton-line--sm" />
          <div className="skeleton-input" />
        </div>
      ))}
      <div className="skeleton-btn skeleton-btn--full skeleton-btn--tall" />
    </div>
  );
}